import React from 'react';
import { Rect as KonvaRect } from 'react-konva';
import useDragShadow from 'components/canvas/components/nodes/hooks/use-drag-shadow';
import { useDoesLinkStartFromNode } from 'state/canvas/node-linking';
import { defaultNodeDimensions } from 'components/canvas/components/nodes';
import { color } from 'styles/settings';
import { SurfaceNodeUnion } from 'graphql/types';
import { useIsNodeSelected } from 'state/canvas/selected-node';
import { riskColors } from 'styles/settings/color';

interface RectProps {
  fill?: string;
  shadowOpacity?: number;
  cornerRadius?: number | number[];
  shadowBlur?: number;
  x?: number;
  y?: number;
  node: SurfaceNodeUnion;
  style: any;
  width?: number;
  height?: number;
}

const defaultProps = {
  x: 0,
  y: 0,
  fill: 'white',
  shadowColor: 'gray',
  shadowBlur: 5,
  shadowOffset: { x: 2, y: 2 },
  shadowOpacity: 0,
  cornerRadius: 5,
};

function Rect(props: RectProps) {
  const ref = React.useRef(null);

  const doesLinkStartFromNode = useDoesLinkStartFromNode(props.node);

  const isSelected = useIsNodeSelected(props.node);

  console.log(' BASE NODE  RECT', props.node, props.node.risk);

  var stroke = {};

  const risk = props.node.risk;
  if (risk) {
    stroke = {
      shadowColor: riskColors[5 - parseInt(risk)],
      // shadowOffset: 30,
      shadowEnabled: true,
      shadowBlur: risk == '5' || risk == '1' ? 60 : 30,
      shadowOpacity: 1,
      // strokeWidth: risk,
    };
  }

  if (isSelected) {
    stroke = {
      ...stroke,
      stroke: doesLinkStartFromNode ? color.brand.blue : color.brand.greenDark,
      strokeWidth: 3,
    };
  }

  const rectProps = {
    id: 'rect-' + props.node.id,
    cornerRadius: props.cornerRadius,
    width: props.width,
    height: props.height,
    ...props.style,
    ...stroke,
  };

  useDragShadow({
    ref,
    node: props.node,
  });

  return <KonvaRect ref={ref} {...props} {...rectProps} />;
}

Rect.defaultProps = defaultProps;

export default Rect;
